import React from 'react'
import { ConversationMessageThread } from '../shared/ConversationMessageThread'
import type { ConversationContentProps } from './ConversationContent'

export const GeneralConversationContent: React.FC<ConversationContentProps> = ({ conversation }) => (
  <ConversationMessageThread messages={conversation.messages} />
)
